import { defineMessages } from "react-intl";

const messages = defineMessages({
    editScore: {
        id: "tasks.melodyTable.editScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    maleOctave: {
        id: "tasks.singing.maleOctave",
    },
    createScoreTooltip: {
        id: "score.saveTooltip",
    },
});

export default messages;
